// EventBus.js
import Vue from 'vue'

const EventBus = new Vue()

export default EventBus
/*
 버스 등록현황
*AppSidebar -> AppHeaderAuthorized
* */
